import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import globalRelay from '../globalRelay';
import proposalModel from '../models/proposalModel';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';
import util from '../util';
import keyboardUtil from '../keyboardUtils';
import { useDragDrop } from '../draggable';
import { DragItemType } from '../dragItemTypes';
import { DayPickerInput } from './dayPickerInput';
import { AsyncButton, Confirm, EditableDiv, Expander, Header, JobCostHiddenWhenLocked, JobCostLockable } from './sharedComponents';
import { getCollection, getModel, ModelCollection } from '../store';

const KEY_DOWN_CODES = [13];

class CreateWorkArea extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { workAreaName: '' };

		this.handleAddWorkArea = this.handleAddWorkArea.bind(this);
		this.handleNameChange = this.handleNameChange.bind(this);
	}

	handleNameChange (e) {
		this.setState({ workAreaName: e.target.value });
	}

	handleAddWorkArea () {
		const { addWorkArea } = this.props;
		const { workAreaName } = this.state;

		if (!workAreaName || workAreaName.length === 0) {
			return;
		}

		if (addWorkArea) {
			this.setState({ workAreaName: '' }, () => {
				addWorkArea(workAreaName);
			});
		}
	}

	render () {
		const { jobCost } = this.props;
		const { workAreaName } = this.state;
		const globalConfig = globalRelay.config!;

		const workAreaOptions = _.map(globalConfig.jobCostSettings.workAreas.defaultAreas, name => {
			return (
				<option key={name} value={name} />
			);
		});

		return (
			<JobCostLockable jobCost={ jobCost } lockedClass="disabled" preventClaimOverride={ true }>{ ({ getClassName }) =>
				(<div className={ getClassName(['inner']) }>
					<table cellPadding="0" cellSpacing="0">
						<tbody>
							<tr>
								<td />
								<td>
									<input type="text" className="dataList" list="workarea" name="workarea" 
										value={workAreaName} placeholder="Enter or Select a New Work Area Name" 
										onChange={this.handleNameChange} 
										onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, this.handleAddWorkArea)}/>
									<datalist id="workarea">
										{ workAreaOptions }
									</datalist>
								</td>
								<td className="action"><button className="icon iconOnly addItem" onClick={this.handleAddWorkArea}><span /></button></td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>)
			}
			</JobCostLockable>
		);
	}
}

// const WorkArea = draggable({
// 	dragItemType: dragItemTypes.PROPOSAL_WORKAREA,
// 	getDragItem: props => { return { key: props.workArea.key, sortIndex: props.workArea.sortIndex }; },
// 	getDropItem: props => { return { key: props.workArea.key }; },
// 	doDrop: (props, dragItem, dropItem) => props.dropWorkArea(dragItem, dropItem),
// 	canDrop: (props, dragItem, dropItem) => dragItem.key !== dropItem.key
// },
// class WorkAreaInner extends React.Component<any,any> {
// 	constructor (props) {
// 		super(props);

// 		this.handleDeleteWorkAreaClick = this.handleDeleteWorkAreaClick.bind(this);
// 		this.deleteWorkArea = this.deleteWorkArea.bind(this);
// 	}

// 	updateModel (path, autoSave, e) {
// 		let newVal;

// 		if (path === 'details') {
// 			newVal = e.target.value;
// 		}
// 		else {
// 			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
// 		}

// 		this.props.updateModel(model => {
// 			model.setAt(path, newVal);
// 		}, { autoSave: autoSave });
// 	}

// 	deleteWorkArea () {
// 		actions.popModal();

// 		this.props.onDeleteWorkArea();
// 	}

// 	handleDeleteWorkAreaClick () {
// 		const popup = <Confirm title="Permanently Delete Work Area?" message="Are you sure you want to permanently delete this Work Area? This cannot be undone." confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ this.deleteWorkArea } />;

// 		actions.popModal();
// 		actions.pushModal({ component: popup });
// 	}

// 	render () {
// 		const {
// 			allowedContractEdits,
// 			connectDragPreview,
// 			connectDropTarget,
// 			connectDragSource,
// 			dragItem,
// 			workArea,
// 			toggleExpander,
// 			isExpanded,
// 			...childProps } = this.props;
// 		const globalConfig = globalRelay.config!;
// 		const rowClassNames = allowedContractEdits === 'none' ? ['readOnly'] : [];
// 		let dropClass;
// 		const details = workArea.details || globalConfig.jobCostSettings.proposal.workAreaDetailsDefault || '';

// 		if (dragItem && dragItem.key !== workArea.key) {
// 			const dropIndex = workArea.sortIndex;
// 			const dragIndex = dragItem.sortIndex;
// 			dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
// 			// console.log(dropClass);
// 		}

// 		const workAreaOptions = _.map(globalConfig.jobCostSettings.workAreas.defaultAreas, name => {
// 			return (
// 				<option key={name} value={name} />
// 			);
// 		});

// 		return (<Expander title={workArea.name} classNames={ ['draggable', 'dropTarget'].concat(dropClass) } isExpanded={ isExpanded } toggleExpander={ toggleExpander } connectDragSource={ allowedContractEdits === 'all' ? connectDragSource : null } connectDragPreview={ allowedContractEdits === 'all' ? connectDragPreview : null } connectDropTarget={ allowedContractEdits === 'all' ? connectDropTarget : null }>
// 			<div className="inner">

// 				<table className="compact" cellPadding="0" cellSpacing="0">
// 					<tbody>
// 						<tr className={ rowClassNames.join(' ') }>
// 							<td />
// 							<td><strong>Name</strong></td>
// 							<td><input type="text" className="dataList" list="workarea" name="workarea" placeholder="Enter or Select the Work Area Name" value={workArea.viewValue('name')} onChange={this.updateModel.bind(this, 'name', false)} onBlur={this.updateModel.bind(this, 'name', true)} />
// 								<datalist id="workarea">
// 									{ workAreaOptions }
// 								</datalist>
// 							</td>
// 							<td />
// 						</tr>
// 						<tr className={ rowClassNames.join(' ') }>
// 							<td />
// 							<td><strong>Details</strong></td>
// 							<td><EditableDiv className="editor" content={ details } onChange={ this.updateModel.bind(this, 'details', false) } onBlur={ this.updateModel.bind(this, 'details', true) } /></td>
// 							<td />
// 						</tr>
// 					</tbody>
// 				</table>
// 				<JobCostHiddenWhenLocked jobCost={ childProps.jobCost }><table className="compact"><tbody><tr><td /><td /><td className="right"><button className="labelOnly deleteItem" onClick={ this.handleDeleteWorkAreaClick }>Delete {_.startCase(workArea.name)}</button></td></tr></tbody></table></JobCostHiddenWhenLocked>
// 			</div>
// 		</Expander>
// 		);
// 	}
// });

function WorkArea(props) {
	const {
		allowedContractEdits,
		customSpecs,
		dropWorkArea,
		workArea,
		specifications,
		hasSpecs,
		toggleExpander,
		isExpanded,
		handleOnKeyDown,
		deleteWorkAreaHandler, 
		updateModel, 
		hasJobCostLineItems, 
		copyFactory, 
		deleteFactory,
		...childProps } = props;
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef}] = useDragDrop({ 
		type: DragItemType.JOBCOST_WORKAREA,
		dragItem: { key: workArea.key, sortIndex: workArea.sortIndex },
		canDrop: (dragItem, dropItem) => dragItem.key !== dropItem.key,
		handleDrop: dropWorkArea
	});
	const handleUpdate = (path, autoSave, e) => {
		e.preventDefault();

		let newVal;

		if (path === 'details') {
			newVal = e.target.value;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}

	const deleteWorkArea = () => {
		actions.popModal();

		deleteWorkAreaHandler(undefined);
	}

	const handleDeleteWorkAreaClick = (workArea, e) => {
		if (hasJobCostLineItems) {
			actions.pushModal({ component: deleteFactory(e) });
		}
		else {
			const popup = <Confirm title="Permanently Delete Work Area?" message="Are you sure you want to permanently delete this Work Area? This cannot be undone." confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ deleteWorkArea } />;

			actions.popModal();
			actions.pushModal({ component: popup });
		}
	}

	const globalConfig = globalRelay.config!;
	const rowClassNames = allowedContractEdits === 'none' ? ['readOnly'] : [];
	const details = workArea.details || globalConfig.jobCostSettings.proposal.workAreaDetailsDefault || '';
	let dropClass;

	if (dropItem && dropItem.key !== workArea.key) {
		const dropIndex = workArea.sortIndex;
		const dragIndex = dropItem.sortIndex;
		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
		// console.log(dropClass);
	}

	const workAreaOptions = _.map(globalConfig.jobCostSettings.workAreas.defaultAreas, name => {
		return (
			<option key={name} value={name} />
		);
	});

	return (<Expander title={workArea.name} classNames={ ['draggable', 'dropTarget'].concat(dropClass) } isExpanded={ isExpanded } toggleExpander={ toggleExpander } dragSourceRef={ allowedContractEdits === 'all' ? dragSourceRef : null } dragPreviewRef={ allowedContractEdits === 'all' ? dragPreviewRef : null } dropTargetRef={ allowedContractEdits === 'all' ? dropTargetRef : null }>
		<div className="inner">

			<table className="compact" cellPadding="0" cellSpacing="0">
				<tbody>
					<tr className={ rowClassNames.join(' ') }>
						<td />
						<td><strong>Name</strong></td>
						<td><input type="text" className="dataList" list="workarea" name="workarea" placeholder="Enter or Select the Work Area Name" value={workArea.viewValue('name')} onChange={e => handleUpdate('name', false, e)} onBlur={e => handleUpdate('name', true, e)} />
							<datalist id="workarea">
								{ workAreaOptions }
							</datalist>
						</td>
						<td />
					</tr>
					<tr className={ rowClassNames.join(' ') }>
						<td />
						<td><strong>Details</strong></td>
						<td><EditableDiv className="editor" content={ details } onChange={ e => handleUpdate('details', false, e) } onBlur={ e => handleUpdate('details', true, e) } /></td>
						<td />
					</tr>
				</tbody>
			</table>
			<JobCostHiddenWhenLocked jobCost={ childProps.jobCost }><table className="compact"><tbody><tr><td /><td /><td className="right"><button className="labelOnly deleteItem" onClick={ e => handleDeleteWorkAreaClick(workArea, e) }>Delete {_.startCase(workArea.name)}</button></td></tr></tbody></table></JobCostHiddenWhenLocked>
		</div>
	</Expander>
	);
}

class ListSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { newItem: '' };

		this.handleKeyUp = this.handleKeyUp.bind(this);
		this.handleAddClick = this.handleAddClick.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	handleKeyUp (e) {
		if (e.keyCode === 13) {
			this.handleAddClick();
		}
	}

	handleAddClick () {
		const { proposal, updateModel, list } = this.props;
		const { newItem } = this.state;

		if (newItem) {
			this.setState({ newItem: '' }, () => {
				const items = proposal[list];

				items.push(newItem);
				updateModel(`/${list}`, items, true);
			});
		}
	}

	handleRemoveClick (index) {
		const { proposal, updateModel, list } = this.props;
		const items = proposal[list];

		items.splice(index, 1);

		updateModel(`/${list}`, items, true);
	}

	handleUpdate (index, autoSave, e) {
		const { proposal, updateModel, list } = this.props;
		const items = proposal[list].concat();
		const newVal = autoSave ? valueFilters.clean(e.target.value) : e.target.value;

		items[index] = newVal;

		updateModel(`/${list}`, items, autoSave);
	}

	render () {
		const { jobCost, proposal, title, list } = this.props;
		const items = proposal[list];
		const { newItem } = this.state;

		return (<section className="expander expanded jobCostProposal">
			<Header title={ title } />
			<JobCostLockable jobCost={ jobCost } lockedClass="disabled" preventClaimOverride={ true }>{ ({ getClassName }) =>
				(<div className={ getClassName(['inner']) }>
					<table className="compact add" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr className="addRow" onKeyUp={ this.handleKeyUp }>
								<td />
								<td>
									<input type="text" placeholder="Enter a Description" 
										autoCorrect="off" value={ newItem } 
										onChange={ e => this.setState({ newItem: e.target.value }) } 
										onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, this.handleAddClick)}/>
								</td>
								<td><button className="icon iconOnly addItem" onClick={ this.handleAddClick }><span /></button></td>
								<td />
							</tr>

							{
								_.map(items, (item, idx) => <tr key={ idx } className="added"><td /><td ><input type="text" placeholder="Enter a Description" autoCorrect="off" value={ item } onChange={ this.handleUpdate.bind(this, idx, false) } onBlur={ this.handleUpdate.bind(this, idx, true) } /></td><td><button className="icon iconOnly removeItem" onClick={ this.handleRemoveClick.bind(this, idx) } ><span /></button></td></tr>)
							}
						</tbody>
					</table>
				</div>)
			}
			</JobCostLockable>
		</section>);
	}
}

const BasicInfoSection = ({ job, jobCost, proposal, updateModel }) => {
	const { store } = componentServices;
	const employees = getCollection({ store, collection: ModelCollection.employees });
	const globalConfig = globalRelay.config!;
	const designerTests = globalConfig.systemRoleEmployeeTitleTests.designer;
	const designers = employees.filter(f => {
		return _.reduce(designerTests, (r, v) => {
			if (!r) {
				const test = new RegExp(v, 'i');
				r = test.test(f.orgTitleKey);
			}
			return r;
		}, false);
	}).sortBy(e => e.fullName);
	const designerOptions:JSX.Element[] = [];

	designerOptions.push(<option key="unknown" value="">Select</option>);

	if (designers) {
		designers.forEach(e => {
			designerOptions.push(<option key={e.key} value={e.key}>{e.fullName}</option>);
		});
	}

	return (<section className="bringToFront">
		<JobCostLockable jobCost={ jobCost } lockedClass="disabled" preventClaimOverride={ true }>{ ({ getClassName }) =>
			(<div className={ getClassName(['inner']) }>
				<div className="contactInfo">
					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr className="">
								<td />
								<td><strong>Date</strong></td>
								<td>
									<DayPickerInput placeholder="Select a Date" selectedDate={ proposal.date } isVertical={ true } onDateSelected={ ({ date }) => updateModel('/date', date ? util.dateHelper.formatDate(date, { format: 'MM/dd/yyyy'} ) : '', true) } />
								</td>
								<td />
							</tr>
							<tr className="">
								<td />
								<td><strong>Proposal Prepared for</strong></td>
								<td><input type="text" placeholder="Enter Homeowner or Business Name" autoCapitalize="" autoCorrect="off" value={ proposal.viewValue('recipient') } onChange={ e => updateModel('/recipient', e.target.value, false)} onBlur={ e => updateModel('/recipient', valueFilters.clean(e.target.value), true) } /></td>
								<td />
							</tr>
						</tbody>
					</table>

					<table className="half" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr className="">
								<td />
								<td><strong>Designer</strong></td>
								<td>
									<select className="select" placeholder="Select" value={ proposal.viewValue('accountManagerKey') } onChange={ e=> updateModel('/accountManagerKey', valueFilters.clean(e.target.value), true) }>
										{ designerOptions }
									</select>
								</td>
								<td />
							</tr>
							<tr className="">
								<td />
								<td><strong>Job Address</strong></td>
								<td><span className="readOnly">{ job.workSiteAddress ? `${job.workSiteAddress.street}, ${job.workSiteAddress.city}, ${job.workSiteAddress.region} ${job.workSiteAddress.postalCode}` : '' }</span></td>
								<td />
							</tr>
						</tbody>
					</table>
				</div>
			</div>)
		}
		</JobCostLockable>
	</section>);
};

export default class JobCostEditProposal extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.printReport = this.printReport.bind(this);
		this.updateModel = this.updateModel.bind(this);
		this.addWorkArea = this.addWorkArea.bind(this);
		this.handleWorkAreaDrop = this.handleWorkAreaDrop.bind(this);

		this.state = {
			workAreaExpanderState: {}
		};
	}

	updateModel (path, newVal, autoSave) {
		this.props.updateModel(model => {
			const proposal = model.proposal || proposalModel();

			proposal.setAt(path, newVal);

			// be sure the setting is written to the setting
			model.proposal = proposal;
		}, { autoSave: autoSave });
	}

	updateWorkArea (workAreaKey, updater, options) {
		this.props.updateModel(model => {
			const proposal = model.proposal || proposalModel();
			const workArea = proposal.workAreas.get(workAreaKey);

			updater(workArea);

			// be sure the setting is written to the setting
			model.proposal = proposal;
		}, options);
	}

	addWorkArea (name) {
		this.props.updateModel(model => {
			const proposal = model.proposal || proposalModel();
			const workArea = proposal.createWorkArea({ name });

			proposal.workAreas[workArea.key] = workArea;

			// be sure the setting is written to the setting
			model.proposal = proposal;
		}, { autoSave: true });
	}

	handleWorkAreaDrop (sourceItem, targetItem) {
		this.props.updateModel(model => {
			const proposal = model.proposal || proposalModel();
			const sourceArea = proposal.workAreas[sourceItem.key];
			const targetArea = proposal.workAreas[targetItem.key];
			const targetSortIndex = targetArea.sortIndex;

			if (sourceArea.sortIndex > targetSortIndex) {
				_.forEach(proposal.workAreas, area => {
					if (area.sortIndex >= targetSortIndex) {
						area.sortIndex += 1;
					}
				});
			}
			else {
				_.forEach(proposal.workAreas, area => {
					if (area.sortIndex <= targetSortIndex) {
						area.sortIndex -= 1;
					}
				});
			}

			sourceArea.sortIndex = targetSortIndex;

			// be sure the setting is written to the setting
			model.proposal = proposal;
		}, { autoSave: true });
	}

	handleDeleteWorkArea (workAreaKey) {
		this.props.updateModel(model => {
			const proposal = model.proposal || proposalModel();

			proposal.workAreas.delete(workAreaKey);

			// be sure the setting is written to the setting
			model.proposal = proposal;
		}, { autoSave: true });
	}

	toggleExpander (workArea) {
		const expanded = this.state.workAreaExpanderState[workArea.key];

		this.setState(previousState => {
			const result = _.assign({}, previousState);

			result.workAreaExpanderState[workArea.key] = typeof (expanded) === 'undefined' ? false : !expanded;

			return result;
		});
	}

	printReport () {
		const { fetchReport } = this.props;

		return fetchReport('contract/proposal');
	}

	render () {
		const { store } = componentServices;
		const { jobCost } = this.props;
		const { workAreaExpanderState } = this.state;
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const allowedContractEdits = jobCost.allowedContractEdits;
		const proposal = jobCost.proposal || proposalModel();
		const titlebarActions = [<AsyncButton className="pdf" asyncAction={ this.printReport } label="Print" />];
		const currentWorkAreas = jobCost.proposal && jobCost.proposal.workAreas ? jobCost.proposal.workAreas.toArray() : [];
		const terms = proposal.terms || globalRelay.config!.jobCostSettings.proposal.termsDefault || '';

		const workAreas = _.map(_.sortBy(currentWorkAreas, 'sortIndex'), workArea => {
			const isExpanded = typeof (workAreaExpanderState[workArea.key]) === 'undefined' ? true : workAreaExpanderState[workArea.key];

			return (
				<WorkArea
					key={workArea.key}
					jobCost={jobCost}
					updateModel={this.updateWorkArea.bind(this, workArea.key)}
					dropWorkArea={ this.handleWorkAreaDrop }
					workArea={workArea}
					deleteWorkAreaHandler={this.handleDeleteWorkArea.bind(this, workArea.key)}
					allowedContractEdits={ allowedContractEdits }
					isExpanded={ isExpanded }
					toggleExpander={ this.toggleExpander.bind(this, workArea) } />
			);
		});

		return (
			<section>
				<Header title="Proposal" actions={ titlebarActions } />
				<BasicInfoSection jobCost={ jobCost } job={ job } proposal={ proposal } updateModel={ this.updateModel } />
				<section className="expander expanded jobCostProposal">
					<Header title="Work Areas" />
					<CreateWorkArea addWorkArea={this.addWorkArea} jobCost={jobCost} allowedContractEdits={ allowedContractEdits } />
					{ workAreas }
				</section>
				<section className="expander expanded jobCostProposal">
					<Header title="Estimated Total Investment" />
					<JobCostLockable jobCost={ jobCost } lockedClass="disabled" preventClaimOverride={ true }>{ ({ getClassName }) =>
						(<div className={ getClassName(['inner']) }>
							<table cellPadding="0" cellSpacing="0">
								<tbody>
									<tr>
										<td />
										<td><input type="text" placeholder="Enter a dollar amount or range" autoCapitalize="" autoCorrect="off" value={ proposal.viewValue('estimatedPrice') } onChange={ e => this.updateModel('/estimatedPrice', e.target.value, false) } onBlur={ e => this.updateModel('/estimatedPrice', e.target.value, true) } /></td>
										<td />
									</tr>
								</tbody>
							</table>
						</div>)
					}
					</JobCostLockable>
				</section>
				<ListSection jobCost={ jobCost } proposal={ proposal } updateModel={ this.updateModel } title="Pricing Includes" list="includedItems" />
				<ListSection jobCost={ jobCost } proposal={ proposal } updateModel={ this.updateModel } title="Pricing Does Not Include" list="excludedItems" />
				<section className="expander expanded jobCostProposal">
					<Header title="Terms & Conditions" />
					<JobCostLockable jobCost={ jobCost } lockedClass="disabled" preventClaimOverride={ true }>{ ({ getClassName }) =>
						(<div className={ getClassName(['inner']) }>
							<table cellPadding="0" cellSpacing="0">
								<tbody>
									<tr>
										<td />
										<td><EditableDiv className="editor" content={ terms } onChange={ e => this.updateModel('/terms', e.target.value, false) } onBlur={ e => this.updateModel('/terms', e.target.value, true) } /></td>
										<td />
									</tr>
								</tbody>
							</table>
						</div>)
					}
					</JobCostLockable>
				</section>
			</section>
		);
	}
}